"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Variant_1 = require("../../../behaviorManager/constants/Variant");
var EqualResolverCondition = (function () {
    function EqualResolverCondition(variant, expectedValue) {
        this.variant = variant;
        this.expectedValue = expectedValue;
    }
    EqualResolverCondition.prototype.evaluate = function (resolverFactory) {
        var resolver = resolverFactory.getResolver(this.variant);
        var actualValue = resolver.get();
        return actualValue === this.expectedValue;
    };
    EqualResolverCondition.prototype.describe = function () {
        return "".concat(Variant_1.Variant[this.variant], " == ").concat(this.expectedValue);
    };
    return EqualResolverCondition;
}());
exports.default = EqualResolverCondition;
